import { Directive, Input, Output, EventEmitter, OnInit, ElementRef, AfterViewInit } from '@angular/core';
import { AppAbstractDirective } from './appAbstractDirective';
import { environment } from '@env/environment';

@Directive({
  selector: '[appDataList]'
})
export class AppDataListDirective extends AppAbstractDirective implements OnInit, AfterViewInit {

  // ********************** Propiedades de la directiva ********************

  // para descripción
  @Input() appServerSearchValue?: string;                 // si se va a buscar por descripcion
  @Input() appNumberTypeValueServerSearch?: number;       // número de caracteres para empezar a filtrar por descripcción
  // para código
  @Input() appServerSearchKey?: string;                   // si se va a buscar por código
  // @Input() appNumberTypeKeyServerSearch?: number;      // número de caracteres para empezar a filtrar por codigo
  // resto
  @Input() appInputId: string;                            // id del imput asociado
  @Input() appMulti = false;                             // si es de selección multiple

  // @Input() appHelpCaracterNumber?: number;                // numero de caracteres máximo del help

  // ********************** Metodos de componente padre ********************

  @Output() appKeyServerSearchMethod = new EventEmitter<any>();         // buscar por código
  @Output() appValueServerSearchMethod = new EventEmitter<any>();       // buscar por desccripción
  @Output() appRemoveDataListMethod = new EventEmitter<any>();          // borrar los elementos de la lista
  // @Output() appElementNotFoundMethod = new EventEmitter<any>();         // metodo padre para cuando no encuentra el elemnto

  @Input() removeOnFocus = true;                                        // borra las opciones cuando está vacío

  // ********************** propiedades de ayuda ***************************

  private isServerSearchValue: boolean;
  private isServerSearchKey: boolean;
  private inputElement: any;

  private readyValue = '';

  // private helpContainerElement: any;
  // private helpContainerText: string;
  // private isShowResultsOnHelpContainer: boolean;
  private isInitialOptions: boolean;
  private serverSearchValue: string;
  private beforeValueSearched: string;

  private helpTimeReaction: number = environment.helpReactionTime;


  // ++++++++++++++++++++++++++++++++++++++++++
  // private elementList: Array<KeyValue>;

  // ********************** Constructor ***********************************

  constructor(
    // elemento tabla de la directiva
    private element: ElementRef
  ) {
    super();
  }

  // ********************** Metdodos de ciclo de vida ********************

  // inicio de la directiva
  ngOnInit(): void {

    // inicio de las variables
    this.isServerSearchValue = (this.appServerSearchValue === 'true' ? true : false);
    this.isServerSearchKey = (this.appServerSearchKey === 'true' ? true : false);
    this.isInitialOptions = false;
    this.serverSearchValue = '';
    // this.isShowResultsOnHelpContainer = false;
    this.beforeValueSearched = '*********************************************************************************';

  }

  ngAfterViewInit(): void {

    this.inputElement = $('#' + this.appInputId);
    const nativeElement = this.element.nativeElement;
    if (nativeElement.childElementCount === 0) {
      this.isInitialOptions = false;
    } else {
      this.isInitialOptions = true;
    }

    if (!this.isInitialOptions) {

      if (!this.isServerSearchKey && !this.isServerSearchValue) {
        this.isServerSearchKey = true;
        this.isServerSearchValue = true;
      }

      if (this.isServerSearchValue) {
        if (this.appNumberTypeValueServerSearch === undefined) {
          if (this.isServerSearchKey) {
            this.appNumberTypeValueServerSearch = 4;
          } else {
            this.appNumberTypeValueServerSearch = 3;
          }
        } else {
          this.appNumberTypeValueServerSearch = +this.appNumberTypeValueServerSearch;
        }
      }

      this.setListener();

    }
  }

  getLastMultiEntry(listString: string): string {
    if (!listString) { return ''; }
    if (listString === '') { return ''; }
    const splitString = listString.split(',');
    return splitString[splitString.length - 1];
  }

  getPreMultiEntries(listString: string): string {
    if (!listString) { return ''; }
    if (listString === '') { return ''; }
    const index = listString.lastIndexOf(',');
    if (index > 0) {
      return listString.substring(0, index + 1);
    } else {
      return '';
    }
  }

// ********************** Metdodos y funciones internas ********************

private setListener() {

  // ...................................................................
  // eventos para el imput..............................................
  if (!this.isInitialOptions) {

    this.inputElement.on('input', () => {

      const inputValue: string = this.inputElement.val();
      if (inputValue.trim() !== '' || !inputValue.startsWith(' ')) {
        let value = inputValue;
        let preValue = '';
        if (this.appMulti) {
          value = this.getLastMultiEntry(inputValue);
          preValue = this.getPreMultiEntries(inputValue);
          if (value.startsWith(' ')) {
            value = value.trim();
            this.inputElement.val(preValue);
          }
        }

        const valueLenght = value.length;
        this.readyValue = value;

        setTimeout(() => {
          if (this.readyValue === value) {
            let mustServerSearch = false;
            let keyServerSearch = false;
            if (valueLenght >= 1) {
              if (this.isServerSearchKey) {
                mustServerSearch = true;
                if (this.isServerSearchValue) {
                  if (valueLenght < this.appNumberTypeValueServerSearch) {
                    keyServerSearch = true;
                  } else {
                    keyServerSearch = false;
                  }
                }
              } else {
                if (valueLenght >= this.appNumberTypeValueServerSearch) {
                  mustServerSearch = true;
                }
              }
              if (mustServerSearch) {
                if (keyServerSearch) {
                    this.beforeValueSearched = value;
                    this.appKeyServerSearchMethod.next({value , preValue});
                } else {
                  if (!value.startsWith(this.beforeValueSearched)) {
                    this.beforeValueSearched = value;
                    this.appValueServerSearchMethod.next({value , preValue});
                  } else {
                    if (this.beforeValueSearched.length < this.appNumberTypeValueServerSearch) {
                      this.beforeValueSearched = value;
                      this.appValueServerSearchMethod.next({value , preValue});
                    }
                  }
                }
              }
            } else {
              this.appRemoveDataListMethod.next(undefined);
            }
          }
        }, this.helpTimeReaction);
      } else {
        this.appRemoveDataListMethod.next(undefined);
        if (inputValue.startsWith(' ')) {
        this.inputElement.val(inputValue.trim());
        }
      }

    });

    this.inputElement.on('focus', () => {

      const inputValue: string = this.inputElement.val();
      if (inputValue === '' && this.removeOnFocus) {
        this.appRemoveDataListMethod.next(undefined);
      }

    });

  }

}

}
